import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';
import API from '../../../../utils/API';
import TimeField from '../../../../components/inputs/timeField';

class EditTicketModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: '',
            description: '',
            startOffsetDays: '',
            endOffsetDays: '',
            startTime: '',
            endTime: '',
            price: 0,
            quantity: 0,
            submitting: false,
            invalid: false,
            success: false,
            requiredFields: {
                label: false,
                description: false,
                startOffsetDays: false,
                endOffsetDays: false,
                price: false,
                quantity: false
            }
        };
    }

    componentDidMount() {
        const { ticket } = this.props;
        if (ticket) {

            this.setState({
                label: ticket.label || '',
                description: ticket.description || '',
                startOffsetDays: ticket.startOffsetDays || '',
                endOffsetDays: ticket.endOffsetDays || '',
                startTime: ticket.startTime || '',
                endTime: ticket.endTime || '',
                price: ticket.price || 0,
                quantity: ticket.quantity || 0
            });
        }
    }

    submit = () => {
        const { orgId, programId, flowId, ticket } = this.props;
        const { label, description, startOffsetDays, endOffsetDays, startTime, endTime, price, quantity } = this.state;

        this.setState({ submitting: true });

        const payload = {
            request: 'updateDefaultEventRegistrationFlowTicket',
            registrationFlow: {
                _id: flowId,
                ticket: {
                    _id: ticket._id,
                    label,
                    description,
                    startOffsetDays,
                    endOffsetDays,
                    startTime,
                    endTime,
                    price,
                    quantity,
                }
            }
        };

        API().patch(`Organizations/${orgId}/programs/${programId}`, payload).then((res) => {
            if (res.data) {
                this.setState({ success: true, submitting: false });
                const updatedFlow = res.data.registrationFlows.find(f => f._id === flowId);
                if (updatedFlow) {
                    const updatedTicket = updatedFlow.tickets.find(t => t._id === ticket._id);
                    if (updatedTicket) {
                        this.props.updateTicket(updatedTicket);
                    }
                }
            } else {
                this.setState({ submitting: false });
            }
        }).catch((err) => {
            this.setState({
                submitting: false,
                error: err.response?.data?.message || 'Error updating ticket'
            });
            console.error('Error updating ticket:', err);
        });
    };

    render() {
        const { isOpen } = this.props;
        const {
            label,
            description,
            startOffsetDays,
            endOffsetDays,
            startTime,
            endTime,
            price,
            quantity,
            submitting,
            success,
            requiredFields
        } = this.state;

        return (
            <div>
                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Edit Registration Ticket"}
                    bodyHeaderText="Update this ticket's information."
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Ticket Label"
                                    classes={'w-100'}
                                    value={label}
                                    onChange={(e) => this.setState({ label: e.target.value })}
                                    required
                                    errorTrigger={requiredFields.label}
                                    name="label"
                                    type="text"
                                    placeholder="Enter ticket label"
                                />
                                <InputField
                                    label="Ticket Description"
                                    classes={'w-100'}
                                    value={description}
                                    onChange={(e) => this.setState({ description: e.target.value })}
                                    required
                                    errorTrigger={requiredFields.description}
                                    name="description"
                                    type="text"
                                    placeholder="Enter ticket description"
                                />
                                <div className='flex gap10'>
                                    <InputField
                                        label="Days before event start"
                                        classes={'w-100'}
                                        value={startOffsetDays}
                                        type="number"
                                        onChange={(e) => this.setState({ startOffsetDays: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.startOffsetDays}
                                        name="startOffsetDays"
                                        placeholder="Enter start date"
                                    />
                                    <TimeField
                                        label="Start Time"
                                        classes={'w-100'}
                                        value={startTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        onChange={(e) => this.setState({ startTime: e })}
                                        errorTrigger={requiredFields.startTime}
                                        name="startTime"
                                        placeholder="Enter start time" />
                                </div>

                                <div className='flex gap10'>
                                    <InputField
                                        label="Days after event start"
                                        classes={'w-100'}
                                        value={endOffsetDays}
                                        type="number"
                                        onChange={(e) => this.setState({ endOffsetDays: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.endOffsetDays}
                                        name="endOffsetDays"
                                        placeholder="Enter end date"
                                    />
                                    <TimeField
                                        label="End Time"
                                        classes={'w-100'}
                                        value={endTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        onChange={(e) => this.setState({ endTime: e })}
                                        errorTrigger={requiredFields.endTime}
                                        name="endTime"
                                        placeholder="Enter end time" />
                                </div>
                                <div className='flex gap10'>
                                    <InputField
                                        label="Price"
                                        classes={'w-100'}
                                        value={price}
                                        type="number"
                                        onChange={(e) => this.setState({ price: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.price}
                                        name="price"
                                        placeholder="Enter ticket price"
                                    />
                                    <InputField
                                        label="Quantity"
                                        classes={'w-100'}
                                        value={quantity}
                                        type="number"
                                        onChange={(e) => this.setState({ quantity: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.quantity}
                                        name="quantity"
                                        placeholder="Enter ticket quantity"
                                    />
                                </div>
                            </div>
                        )
                    }}
                    toggle={this.props.toggle}
                    actionButtonLabel={!success ? !submitting ? 'Update' : 'Updating...' : ''}
                    cancelButtonLabel={success ? 'Close' : 'Cancel'}
                    actionButton={() => this.submit()}
                    submitting={submitting}
                    actionButtonDisabled={submitting || success}
                ></FieldModal>
            </div>
        )
    }
}

export default EditTicketModal;
